import { DeviceTypes } from '@/enums';

/**
 * Checks the current device type of user
 * @returns
 */
export const deviceType = () => {
  const userAgent = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    return DeviceTypes.TABLET;
  }
  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)) {
    return DeviceTypes.MOBILE;
  }
  return DeviceTypes.DESKTOP;
};
